/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetadataValueRenderType } from './MetadataValueRenderType';
import {
  MetadataValueRenderTypeFromJSON,
  MetadataValueRenderTypeFromJSONTyped,
  MetadataValueRenderTypeToJSON,
  MetadataValueRenderTypeToJSONTyped,
} from './MetadataValueRenderType';

/**
 * A typed metadata value with an optional rendering hint for the UI.
 * @export
 * @interface V2beta1MetadataValue
 */
export interface V2beta1MetadataValue {
  /**
   *
   * @type {object}
   * @memberof V2beta1MetadataValue
   */
  value?: object;
  /**
   *
   * @type {MetadataValueRenderType}
   * @memberof V2beta1MetadataValue
   */
  render_type?: MetadataValueRenderType;
}

/**
 * Check if a given object implements the V2beta1MetadataValue interface.
 */
export function instanceOfV2beta1MetadataValue(value: object): value is V2beta1MetadataValue {
  return true;
}

export function V2beta1MetadataValueFromJSON(json: any): V2beta1MetadataValue {
  return V2beta1MetadataValueFromJSONTyped(json, false);
}

export function V2beta1MetadataValueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1MetadataValue {
  if (json == null) {
    return json;
  }
  return {
    value: json['value'] == null ? undefined : json['value'],
    render_type:
      json['render_type'] == null
        ? undefined
        : MetadataValueRenderTypeFromJSON(json['render_type']),
  };
}

export function V2beta1MetadataValueToJSON(json: any): V2beta1MetadataValue {
  return V2beta1MetadataValueToJSONTyped(json, false);
}

export function V2beta1MetadataValueToJSONTyped(
  value?: V2beta1MetadataValue | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value['value'],
    render_type: MetadataValueRenderTypeToJSON(value['render_type']),
  };
}
